export default "__VITE_ASSET__CO218FMG__"